import {
  Autocomplete,
  Button,
  CircularProgress,
  MenuItem,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import GayrimenkulBulPopUp from "../../../components/OB/PopUp";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import { arsaBasvuruValidationSchema } from "../../../validations/EmlakBasvuru";
import ArsaBasvuruSave from "../../../apis/OB/SaveApi/ArsaBasvuruSave";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import SessionStorageService from "../../../services/StorageService";
import CustomTextField from "../../../components/OB/required-text-field";
import CustomDatePicker from "../../../components/OB/required-datepicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { filterOptions } from "../../../helpers/TodayDate";
import DysAPI from "../../../apis/DysAPI";
import Recaptcha from "../../../components/Recaptcha";
import { useFormConfig } from "../../../hooks/useFormConfig";
import ConfigurableField from "../../../components/OB/ConfigurableField";

const ArsaBasvuru = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const user = SessionStorageService.getUserInfo()

  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };

  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<number | null>(null);
  const [caddeListe, setCaddeListe] = useState<any[]>([]);
  const { mahalleListe } = useContext(ConstantAPISContext);
  const [open, setOpen] = useState(false); 

  const openPopup = () => {
    setOpen(true);
  };

  const closePopup = () => {
    setOpen(false);
  };
  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  // Dinamik Form Konfigurasyon Hook
  const { config, isFieldVisible, getFieldLabel, buildValidationSchema } = useFormConfig('ARSA_BASVURU');

  const handleDecimalChange = (fieldName: string, value: string, setFieldValue: any) => {
    const formatted = value
      .replace(/[^0-9.]/g, "") // Rakamlar ve noktalar dışındaki karakterleri kaldır
      .replace(/^0+([1-9])/, "$1") // Başındaki gereksiz sıfırları kaldır
      .replace(/^0+\./, "0.") // 00. -> 0. düzelt
      .replace(/^[.]/, "0.") // Nokta ile başlarsa önüne 0 ekle
      .replace(/\./g, (match: any, i: any, original: any) =>
        i === original.indexOf(".") ? "." : ""
      ) // Yalnızca ilk noktayı bırak, diğerlerini sil
      .replace(/(\.\d{2})\d+/, "$1") // Ondalık noktadan sonra sadece iki basamak olacak şekilde sınırla
      .replace(/^-/, ""); // Negatif işareti kaldır

    setFieldValue(fieldName, formatted);
  };

  const handleDecimalBlur = (fieldName: string, value: string, setFieldValue: any) => {
    if (value && !value.includes(".")) {
      setFieldValue(fieldName, `${value}.00`);
    } else if (value && value.endsWith(".")) {
      setFieldValue(fieldName, `${value}00`);
    } else if (value && value.split(".")[1]?.length === 1) {
      setFieldValue(fieldName, `${value}0`);
    }
  };


  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };
  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 2 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);
  useEffect(() => {
    if (selectedMahalleKodu) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
        .then((res) => {
          setCaddeListe(res.data);
        })
        .catch(() => {
          console.log("hata");
        });
    } else {
      setCaddeListe([]);
    }
  }, [selectedMahalleKodu]);

  return (
    <Formik
      validateOnMount={true}
      initialValues={{
        basvuruTuruId: 2,
        sicilKodu: user?.sicilKodu,
        mahalleKodu: '',
        caddeSokakKodu: '',
        tapuBagimsizNo: '',
        kapiNo: '',
        pafta: '',
        ada: '',
        parsel: '',
        pismanlikIndirimi: '',
        arsaYuzolcumu: '',
        arsaHisse: '',
        altKapiNo: '',
        siteApartmanAdi: '',
        daireNo: '',
        altDaireNo: '',
        blokNo: '',
        katNo: '',
        arsaOran: '',
        arsa2Hisse: '1.00',
        arsa2Oran: '1.00',
        hisseyeDusenArsaYuzolcumu: '',
        edinmeTarihi: null,
        aciklama: '',
        tapuCiltNo: '',
        tapuSayfaNo: '',
        tapuYevmiyeNo: '',
        tapuYevmiyeTarihi: null,
      }}
      validationSchema={buildValidationSchema(arsaBasvuruValidationSchema)}
      onSubmit={async (values: any, { resetForm }) => {
        const missingDocuments = documents
          .filter(doc => doc.isRequired) // zorunlu belgeler
          .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
          const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
          toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
          documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          return; // başvuru burada durur
        }
        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
          toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
          return;
        }

        setLoadingSubmit(true);
        const formattedValues = {
          ...values,
          ada: values.ada != "" ? safelyParseNumber(values.ada) : null,
          parsel: values.parsel != "" ? safelyParseNumber(values.parsel) : null,
          kapiNo: safelyParseNumber(values.kapiNo),
          daireNo: values.daireNo != "" ? safelyParseNumber(values.daireNo) : null,
          tapuCiltNo: values.tapuCiltNo != "" ? safelyParseNumber(values.tapuCiltNo) : null,
          tapuSayfaNo: values.tapuSayfaNo != "" ? safelyParseNumber(values.tapuSayfaNo) : null,
          arsaYuzolcumu: safelyParseNumber(values.arsaYuzolcumu),
          arsaHisse: safelyParseNumber(values.arsaHisse),
          arsaOran: safelyParseNumber(values.arsaOran),
          arsa2Hisse: safelyParseNumber(values.arsa2Hisse),
          arsa2Oran: safelyParseNumber(values.arsa2Oran),
          hisseyeDusenArsaYuzolcumu: safelyParseNumber(values.hisseyeDusenArsaYuzolcumu),
          edinmeTarihi: values.edinmeTarihi != null ? dayjs(values.edinmeTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          tapuYevmiyeTarihi: values.tapuYevmiyeTarihi != null ? dayjs(values.tapuYevmiyeTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          sicilKodu: safelyParseNumber(values.sicilKodu) || 0,
          captchaToken: token

        };
        ArsaBasvuruSave.saveArsaBasvuruSave(formattedValues).then(async (res) => {
          console.log(res)
          if (res.data.sonuc === 0) {
            let basvuruNo = res.data.basvuruNo;

            // DYS API'yi çağır 
            try {
              // Sadece dosyası olanları al
              const filesToSend = documents.filter((doc: any) => !!doc.file);

              if (filesToSend.length > 0) {
                const formData = new FormData();

                filesToSend.forEach((doc: any) => {
                  formData.append("files", doc.file, doc.file.name);
                  formData.append("rfObBasvuruTanimBelge", String(doc.id));
                });

                formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                formData.append("basvuruId", String(basvuruNo));
                formData.append("folderName", "AKOS");
                formData.append("kurumId", "1");
                formData.append("versionable", "1");

                const response = await DysAPI.upload(formData);
                toast.warning(response.message);
              } else {
                // Burada return yok — sadece DYS çağrısını atlıyoruz.
                
              }
            } catch (error: any) {
              toast.error("DYS upload hazırlama hatası:", error);
            }

            setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
            resetForm();
            setKayitBasarili(true);
            setDocuments((prevDocs: any[]) =>
              prevDocs.map((doc) => ({
                ...doc,
                file: null,
                fileName: "",
              }))
            );
          } else {
            setPopupAciklama(res.data.sonucAciklama);
          }
        }).catch((err) => {
          setPopupAciklama(
            "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
          );
        }).finally(() => {
          setIsPopupVisible(true);
          recaptchaRef.current?.reset();
          setLoadingSubmit(false);
        });
      }}
    >
      {(formikProps) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          console.log('Formik Errors:', formikProps.errors);
        }, [formikProps.errors]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (
            formikProps.values.arsaOran !== "" &&
            formikProps.values.arsaHisse !== "" &&
            formikProps.values.arsaYuzolcumu !== ""
          ) {
            let result =
              Number(formikProps.values.arsaYuzolcumu) *
              (Number(formikProps.values.arsaHisse) /
                Number(formikProps.values.arsaOran))
              * (Number(formikProps.values.arsa2Hisse || 1.00) /
                Number(formikProps.values.arsa2Oran || 1.00));
            formikProps.setFieldValue(
              "hisseyeDusenArsaYuzolcumu",
              result.toString()
            );
          }
        }, [formikProps.values.arsaOran, formikProps.values.arsaHisse, formikProps.values.arsaYuzolcumu, formikProps.values.arsa2Hisse, formikProps.values.arsa2Oran]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showToastIfErrorsExist = () => {
          if (Object.keys(formikProps.errors).length > 0) {
            focusFirstErrorField();
            toast.error("Lütfen zorunlu alanları doldurun!");

          }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formRefs = useRef<any>({});
        const focusFirstErrorField = () => {
          const errorKeys = Object.keys(formikProps.errors);
          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0];
            console.log(errorKeys[0])
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        };

        return (
          <Form>
            <div className="row">
              <div className="col-12 mb-2">
                <div className="d-flex justify-content-between align-self-stretch">
                  <Button
                    onClick={openPopup}
                    type="button"
                    color="warning"
                  >
                    Gayrimenkul Bul
                  </Button>
                  <Button

                    type="button"

                    color="secondary"

                    onClick={() => {
                      formikProps.resetForm({ values: formikProps.initialValues });
                      setDocuments((prevDocs: any[]) =>
                        prevDocs.map((doc) => ({
                          ...doc,
                          file: null,
                          fileName: "",
                        }))
                      );
                    }}
                  >

                    Temizle
                  </Button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="mahalleKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="mahalleKodu"
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("mahalleKodu", "Mahalle *")}
                          size="small"
                          value={formikProps.values.mahalleKodu}
                          onChange={(value: any) => {
                            formikProps.setFieldValue("mahalleKodu", Number(value.target.value));
                            setSelectedMahalleKodu(Number(value.target.value));
                            formikProps.setFieldValue("caddeSokakKodu", null);
                          }}
                          error={formikProps.errors.mahalleKodu && formikProps.touched.mahalleKodu ? true : false}
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {mahalleListe.map((option) => (
                            <MenuItem key={option.mahalleKodu} value={option.mahalleKodu}>
                              {option.mahalleAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="caddeSokakKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="caddeSokakKodu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          select
                          label={getFieldLabel("caddeSokakKodu", "Cadde/Sokak *")}
                          value={formikProps.values.caddeSokakKodu}
                          onChange={(value: any) => formikProps.setFieldValue("caddeSokakKodu", Number(value.target.value))}
                          error={formikProps.errors.caddeSokakKodu && formikProps.touched.caddeSokakKodu ? true : false}
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {caddeListe.map((option) => (
                            <MenuItem key={option.caddeSokakKodu} value={option.caddeSokakKodu}>
                              {option.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="kapiNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="kapiNo"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("kapiNo", "Kapı No *")}
                          value={formikProps.values.kapiNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("kapiNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                          }
                          error={formikProps.errors.kapiNo && formikProps.touched.kapiNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="altKapiNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("altKapiNo", "Alt Kapı No")}
                          {...formikProps.getFieldProps("altKapiNo")}
                          error={formikProps.errors.altKapiNo && formikProps.touched.altKapiNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="daireNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          name="daireNo"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("daireNo", "Daire No")}
                          value={formikProps.values.daireNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("daireNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                          }
                          error={formikProps.errors.daireNo && formikProps.touched.daireNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="altDaireNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("altDaireNo", "Alt Daire No")}
                          {...formikProps.getFieldProps("altDaireNo")}
                          error={formikProps.errors.altDaireNo && formikProps.touched.altDaireNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <ConfigurableField fieldName="siteApartmanAdi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                    <div className="row">
                      <div className="col-12">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("siteApartmanAdi", "Site/Apartman Adı")}
                          {...formikProps.getFieldProps("siteApartmanAdi")}
                          error={formikProps.errors.siteApartmanAdi && formikProps.touched.siteApartmanAdi ? true : false}
                          variant="outlined"
                        />
                      </div>
                    </div>
                    </ConfigurableField>
                    <div className="row">
                      <ConfigurableField fieldName="blokNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6 mb-3 mb-lg-0">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("blokNo", "Blok No")}
                          {...formikProps.getFieldProps("blokNo")}
                          error={formikProps.errors.blokNo && formikProps.touched.blokNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="katNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6 mb-3 mb-lg-0">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("katNo", "Kat No")}
                          {...formikProps.getFieldProps("katNo")}
                          error={formikProps.errors.katNo && formikProps.touched.katNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="pafta" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("pafta", "Pafta *")}
                          {...formikProps.getFieldProps("pafta")}
                          error={formikProps.errors.pafta && formikProps.touched.pafta ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="ada" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="ada"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("ada", "Ada *")}
                          value={formikProps.values.ada}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("ada", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                          }
                          error={formikProps.errors.ada && formikProps.touched.ada ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="parsel" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="parsel"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("parsel", "Parsel *")}
                          value={formikProps.values.parsel}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("parsel", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                          }
                          error={formikProps.errors.parsel && formikProps.touched.parsel ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuBagimsizNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("tapuBagimsizNo", "Tapu Bağımsız No")}
                          {...formikProps.getFieldProps("tapuBagimsizNo")}
                          error={formikProps.errors.tapuBagimsizNo && formikProps.touched.tapuBagimsizNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="tapuCiltNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("tapuCiltNo", "Tapu Cilt No")}
                          value={formikProps.values.tapuCiltNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("tapuCiltNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 7) : "")
                          }
                          error={formikProps.errors.tapuCiltNo && formikProps.touched.tapuCiltNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuSayfaNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("tapuSayfaNo", "Tapu Sayfa No")}
                          value={formikProps.values.tapuSayfaNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("tapuSayfaNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 7) : "")
                          }
                          error={formikProps.errors.tapuSayfaNo && formikProps.touched.tapuSayfaNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="tapuYevmiyeNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("tapuYevmiyeNo", "Tapu Yevmiye No")}
                          {...formikProps.getFieldProps("tapuYevmiyeNo")}
                          error={formikProps.errors.tapuYevmiyeNo && formikProps.touched.tapuYevmiyeNo ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuYevmiyeTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <DatePicker
                          slotProps={{
                            textField: { size: "small", fullWidth: true },
                          }}
                          label={getFieldLabel("tapuYevmiyeTarihi", "Tapu Yevmiye Tarihi")}
                          value={formikProps.values.tapuYevmiyeTarihi}
                          onChange={(value) => formikProps.setFieldValue("tapuYevmiyeTarihi", value)}
                          className="mb-3"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row mb-3 mb-lg-0">
                      <ConfigurableField fieldName="arsaYuzolcumu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="arsaYuzolcumu"
                          fullWidth
                          size="small"
                          label={getFieldLabel("arsaYuzolcumu", "Arsa Yüzölçümü *")}
                          value={formikProps.values.arsaYuzolcumu}
                          onChange={(e: any) =>
                            handleDecimalChange("arsaYuzolcumu", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsaYuzolcumu", e.target.value, formikProps.setFieldValue)
                          }
                          error={formikProps.errors.arsaYuzolcumu && formikProps.touched.arsaYuzolcumu ? true : false}
                          className="pb-2 pb-lg-0"
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="arsaHisse" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="arsaHisse"
                          fullWidth
                          size="small"
                          label={getFieldLabel("arsaHisse", "Arsa Hisse *")}
                          value={formikProps.values.arsaHisse}
                          onChange={(e: any) =>
                            handleDecimalChange("arsaHisse", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsaHisse", e.target.value, formikProps.setFieldValue)
                          }
                          error={formikProps.errors.arsaHisse && formikProps.touched.arsaHisse ? true : false}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-sm-2 mt-xxl-0 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="arsaOran" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="arsaOran"
                          fullWidth
                          size="small"
                          label={getFieldLabel("arsaOran", "Arsa Oran *")}
                          value={formikProps.values.arsaOran}
                          onChange={(e: any) =>
                            handleDecimalChange("arsaOran", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsaOran", e.target.value, formikProps.setFieldValue)
                          }
                          error={formikProps.errors.arsaOran && formikProps.touched.arsaOran ? true : false}
                          className="mb-3"
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="arsa2Hisse" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          name="arsa2Hisse"
                          fullWidth
                          size="small"
                          label={getFieldLabel("arsa2Hisse", "Arsa 2 Hisse")}
                          value={formikProps.values.arsa2Hisse || "1.00"}
                          onChange={(e: any) =>
                            handleDecimalChange("arsa2Hisse", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsa2Hisse", e.target.value, formikProps.setFieldValue)
                          }
                          error={formikProps.errors.arsa2Hisse && formikProps.touched.arsa2Hisse ? true : false}
                          className="mb-3"
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="arsa2Oran" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          name="arsa2Oran"
                          fullWidth
                          size="small"
                          label={getFieldLabel("arsa2Oran", "Arsa 2. Oran")}
                          value={formikProps.values.arsa2Oran || "1.00"}
                          onChange={(e: any) =>
                            handleDecimalChange("arsa2Oran", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsa2Oran", e.target.value, formikProps.setFieldValue)
                          }
                          error={formikProps.errors.arsa2Oran && formikProps.touched.arsa2Oran ? true : false}
                          className="mb-3"
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="hisseyeDusenArsaYuzolcumu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("hisseyeDusenArsaYuzolcumu", "Hisseye Düşen Arsa Yüzölçümü")}
                          {...formikProps.getFieldProps("hisseyeDusenArsaYuzolcumu")}
                          error={formikProps.errors.hisseyeDusenArsaYuzolcumu && formikProps.touched.hisseyeDusenArsaYuzolcumu ? true : false}
                          className="mb-3"
                          variant="outlined"
                          disabled
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="pismanlikIndirimi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6 ">
                        <TextField
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("pismanlikIndirimi", "Pişmanlık İndirimi")}
                          size="small"
                          {...formikProps.getFieldProps("pismanlikIndirimi")}
                          error={formikProps.errors.pismanlikIndirimi && formikProps.touched.pismanlikIndirimi ? true : false}
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          <MenuItem selected value={"E"}>
                            {"Evet"}
                          </MenuItem>
                          <MenuItem selected value={"H"}>
                            {"Hayır"}
                          </MenuItem>
                        </TextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="edinmeTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomDatePicker
                          name="edinmeTarihi"
                          slotProps={{
                            textField: {
                              size: "small", fullWidth: true,
                              error:
                                formikProps.errors.edinmeTarihi &&
                                  formikProps.touched.edinmeTarihi
                                  ? true
                                  : false,
                            },
                          }}
                          label={getFieldLabel("edinmeTarihi", "Edinme Tarihi *")}
                          value={formikProps.values.edinmeTarihi}
                          onChange={(value: any) => formikProps.setFieldValue("edinmeTarihi", value)}
                          className="mb-3"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="aciklama" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="row pe-0">
                        <div className="col-12 pe-0">
                          <TextField
                            id="outlined-multiline-flexible"
                            label={getFieldLabel("aciklama", "Açıklama")}
                            {...formikProps.getFieldProps("aciklama")}
                            error={formikProps.errors.aciklama && formikProps.touched.aciklama ? true : false}
                            rows={2.76}
                            fullWidth
                            multiline
                            maxRows={10}
                          />
                        </div>
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div ref={documentTableRef}>
                {!docsLoaded ? (
                  <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                ) : (
                  <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                )}
              </div>
              <div className="col-12 mt-3">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Recaptcha
                    ref={recaptchaRef}
                    changeHandleRecaptcha={setRecaptchaPassed}
                  />
                  <Button
                    onClick={() => showToastIfErrorsExist()}
                    type="submit"
                  >
                    Gönder
                  </Button>
                  {loadingSubmit && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(255,255,255,0.6)",
                        zIndex: 1300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </div>
              {open && (
                <GayrimenkulBulPopUp
                  onSelectEmlak={(emlak: any) => {
                    if (emlak) {
                      formikProps.setFieldValue("pafta", emlak.pafta);
                      formikProps.setFieldValue("ada", emlak.ada);
                      formikProps.setFieldValue("parsel", emlak.parsel);
                      formikProps.setFieldValue("mahalleKodu", emlak.mahalleKodu);
                      setSelectedMahalleKodu(emlak.mahalleKodu)
                      formikProps.setFieldValue("caddeSokakKodu", emlak.caddeSokakKodu);
                      formikProps.setFieldValue("tapuBagimsizNo", emlak.tapuBagimsizNo);
                      formikProps.setFieldValue("kapiNo", emlak.kapiNo);
                      closePopup();
                    }
                  }}
                  open={open}
                  onClose={setOpen}
                  type="2"
                />
              )}
              {isPopupVisible && (
                <BilgilendirmePopup
                  basvuruTuruId={formikProps.values.basvuruTuruId}
                  isSorunBildirPopup={!kayitBasarili}
                  closePopup={closePopupSonuc}
                  open={isPopupVisible}
                  editDescription={popupAciklama}
                />
              )}

            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ArsaBasvuru;
